import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { generatePDFRechnungToLink } from "./../../funktionen/generatePDFRechnungToLink.js";
import Vue from "vue";

// initial state
const state = {
  mails: [],
  kassen: [],
  veranstaltungen: [],
  bbrbbr: [],
  einstellungen: [],
  loading: false,
  loaded: false,
  error: null,
};

// getters
const getters = {
  mails(state) {
    return state.mails;
  },
  eigeneMails: (state) => (id) => {
    let items = [];
    state.mails.forEach((item) => {
      if (item.an) {
        if (item.an.indexOf(id) !== -1) {
          if (items.indexOf(item) === -1) {
            items.push(item);
          }
        }
      }
      if (item.an_cc) {
        if (item.an_cc.indexOf(id) !== -1) {
          if (items.indexOf(item) === -1) {
            items.push(item);
          }
        }
      }
      if (item.an_bcc) {
        if (item.an_bcc.indexOf(id) !== -1) {
          if (items.indexOf(item) === -1) {
            items.push(item);
          }
        }
      }
      if (item.an_gruppen) {
        if (item.an_gruppen.indexOf(id) !== -1) {
          if (items.indexOf(item) === -1) {
            items.push(item);
          }
        }
      }
    });
    return items;
  },
  gesendeteMails: (state) => (id) => {
    let items = [];
    state.mails.forEach((item) => {
      if (item.von) {
        if (item.von.indexOf(id) !== -1) {
          items.push(item);
        }
      }
    });
    return items;
  },
  entwurfAndErrorMails: (state) => {
    return state.mails.filter((item) => item.status === "Entwurf" || item.status === "Error");
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
};

// actions
const actions = {
  loadMails({ commit }) {
    commit("setLoading", true);
    console.log("Mails laden...");
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("mails")
      .orderBy("datum", "desc")
      .onSnapshot(
        (snapshot) => {
          const mails = [];
          snapshot.forEach((doc) => {
            mails.push({
              ...doc.data(),
              id: doc.id,
            });
            commit("setLoadedMails", mails);
            commit("setLoading", false);
            commit("setLoaded", true);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  loadKassen({ commit }) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("einstellungen")
      .doc("kassen")
      .get()
      .then((doc) => {
        if (doc.exists) {
          commit("setLoadedKassen", doc.data());
          commit("setLoading", false);
        } else {
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
        commit("setLoading", false);
      });
  },
  loadBbrBbr({ commit }) {
    commit("setLoading", true);
    console.log("Bundesbrüder laden...");
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("kontakte")
      .orderBy("nachname")
      .onSnapshot(
        (snapshot) => {
          const bbrbbr = [];
          snapshot.forEach((doc) => {
            if (!doc.data().delete) {
              bbrbbr.push({
                ...doc.data(),
                id: doc.id,
              });
            }
            commit("setLoadedBbrBbr", bbrbbr);
            commit("setLoading", false);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  loadEinstellungen({ commit }) {
    commit("setLoading", true);
    console.log("Mails/Einstellungen laden...");
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("einstellungen")
      .onSnapshot(
        (snapshot) => {
          const einstellungen = [];
          snapshot.forEach((doc) => {
            einstellungen.push({
              ...doc.data(),
              id: doc.id,
            });
            commit("setLoadedEinstellungen", einstellungen);
            commit("setLoading", false);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  loadVeranstaltungen({ commit }) {
    commit("setLoading", true);
    let today = new Date().toISOString().substr(0, 10);
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("veranstaltungen")
      .where("vonDatum", ">=", today)
      .orderBy("vonDatum", "asc")
      .limit(3)
      .onSnapshot(
        (snapshot) => {
          const veranstaltungen = [];
          snapshot.forEach((doc) => {
            veranstaltungen.push({
              ...doc.data(),
              id: doc.id,
            });
            commit("setLoadedVeranstaltungen", veranstaltungen);
            commit("setLoading", false);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  async createEinMails({ commit, getters }, payload) {
    let html;
    const settings = state.einstellungen.find((item) => item.id === "allgemein");
    if (payload.art === "mail") {
      payload.from = payload.absender.position;
      if (payload.template) {
        html = payload.template;
      } else {
        html = payload.message.text;
      }
      html = html.replace(/<<nachricht.inhalt>>/g, payload.message.text);
      html = html.replace(/<<nachricht.titel>>/g, payload.message.subject);
      html = html.replace(/<<nachricht.datum>>/g, new Date(payload.datum).toISOString());
      html = html.replace(/<<absender.vorname>>/g, payload.absender.vorname);
      html = html.replace(/<<absender.nachname>>/g, payload.absender.nachname);
      html = html.replace(/<<absender.name>>/g, payload.absender.vorname + " " + payload.absender.nachname);
      html = html.replace(/<<absender.adresse>>/g, payload.absender.adresse);
      html = html.replace(/<<absender.plz>>/g, payload.absender.plz);
      html = html.replace(/<<absender.ort>>/g, payload.absender.ort);
      html = html.replace(/<<absender.email>>/g, payload.absender.email);
      html = html.replace(/<<absender.handy>>/g, payload.absender.handy);
      html = html.replace(/<<absender.telefon>>/g, payload.absender.telefon);
      html = html.replace(/<<absender.position>>/g, payload.absender.position);
      let veranstaltung1;
      let veranstaltung2;
      let veranstaltung3;
      if (state.veranstaltungen.length > 0) {
        veranstaltung1 =
          state.veranstaltungen[0].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[0].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[0].titel;
      } else {
        veranstaltung1 = "";
      }
      if (state.veranstaltungen.length > 1) {
        veranstaltung2 =
          state.veranstaltungen[1].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[1].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[1].titel;
      } else {
        veranstaltung2 = "";
      }
      if (state.veranstaltungen.length > 2) {
        veranstaltung3 =
          state.veranstaltungen[2].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[2].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[2].titel;
      } else {
        veranstaltung3 = "";
      }
      let veranstaltungen =
        "<h4>Veranstaltungen</h4>" + veranstaltung1 + "<br>" + veranstaltung2 + "<br>" + veranstaltung3 + "<br>";
      html = html.replace("<<Veranstaltungen>>", veranstaltungen);
    }
    if (payload.art === "rechnung") {
      const kasse = state.kassen[payload.rechnung.kasse];
      const bbr = state.bbrbbr.find((bbr) => bbr.id === payload.rechnung.bbrID);
      payload.from = kasse.absender;
      if (kasse.template) {
        html = kasse.template;
      } else {
        html = payload.message.text;
      }
      let positionsliste = "";
      let nummer = 1;
      payload.rechnung.positionen.forEach((position) => {
        positionsliste = positionsliste + '<tr style="height: 36px;">';
        positionsliste = positionsliste + '<td style="border-bottom: 1px solid black; text-align:center;">';
        positionsliste = positionsliste + nummer;
        positionsliste = positionsliste + '</td><td style="border-bottom: 1px solid black;">';
        positionsliste = positionsliste + position.was;
        positionsliste = positionsliste + '</td><td style="border-bottom: 1px solid black;text-align:right;">';
        if (typeof position.betrag === "string") {
          positionsliste = positionsliste + parseFloat(position.betrag.replace(",", ".")).toFixed(2);
        } else {
          positionsliste = positionsliste + parseFloat(position.betrag).toFixed(2);
        }
        positionsliste = positionsliste + " €</td></tr>";
        nummer = nummer + 1;
      });
      html = html.replace(/<<nachricht.inhalt>>/g, payload.message.text);
      html = html.replace(/<<nachricht.titel>>/g, payload.message.subject);
      html = html.replace(/<<nachricht.datum>>/g, new Date(payload.datum).toISOString());
      html = html.replace(/<<absender.vorname>>/g, payload.absender.vorname);
      html = html.replace(/<<absender.nachname>>/g, payload.absender.nachname);
      html = html.replace(/<<absender.name>>/g, payload.absender.name);
      html = html.replace(/<<absender.adresse>>/g, payload.absender.adresse);
      html = html.replace(/<<absender.plz>>/g, payload.absender.plz);
      html = html.replace(/<<absender.ort>>/g, payload.absender.ort);
      html = html.replace(/<<absender.email>>/g, payload.absender.email);
      html = html.replace(/<<absender.handy>>/g, payload.absender.handy);
      html = html.replace(/<<absender.telefon>>/g, payload.absender.telefon);
      html = html.replace(/<<absender.position>>/g, payload.absender.position);
      html = html.replace(/<<positionsliste>>/g, positionsliste);
      html = html.replace(/<<summe>>/g, parseFloat(payload.rechnung.summe).toFixed(2));
      html = html.replace(/<<kasse.kontoname>>/g, kasse.kontoname);
      html = html.replace(/<<kasse.bank>>/g, kasse.bank);
      html = html.replace(/<<kasse.iban>>/g, kasse.IBAN);
      html = html.replace(/<<kasse.bic>>/g, kasse.BIC);
      let veranstaltung1;
      let veranstaltung2;
      let veranstaltung3;
      if (state.veranstaltungen.length > 0) {
        veranstaltung1 =
          state.veranstaltungen[0].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[0].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[0].titel;
      } else {
        veranstaltung1 = "";
      }
      if (state.veranstaltungen.length > 1) {
        veranstaltung2 =
          state.veranstaltungen[1].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[1].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[1].titel;
      } else {
        veranstaltung2 = "";
      }
      if (state.veranstaltungen.length > 2) {
        veranstaltung3 =
          state.veranstaltungen[2].vonDatum.substr(8, 2) +
          "." +
          state.veranstaltungen[2].vonDatum.substr(5, 2) +
          ". " +
          state.veranstaltungen[2].titel;
      } else {
        veranstaltung3 = "";
      }
      let veranstaltungen =
        "<h4>Veranstaltungen</h4>" + veranstaltung1 + "<br>" + veranstaltung2 + "<br>" + veranstaltung3 + "<br>";
      html = html.replace("<<Veranstaltungen>>", veranstaltungen);
      let url = await generatePDFRechnungToLink(payload.rechnung, kasse, bbr, settings, Vue.prototype.$vars.verbindung);
      payload.attachments = [
        {
          filename: payload.rechnung.rechnungsnummer + ".pdf",
          path: url,
        },
      ];
    }
    if (payload.absender.position === null) {
      payload.absender.position = "";
    }
    payload.message.html = html;
    payload.log = [
      {
        status: "Postausgang",
        time: new Date(),
      },
    ];
    console.log(payload);
    // let string = JSON.stringify(payload)
    // payload = JSON.parse(string)
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("mails")
      .add(payload)
      .then(() => {
        console.log("Queued email for delivery!");
      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
  },
  deleteEinMailsData({ commit }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("mails")
      .doc(payload)
      .delete()
      .then(() => {
        commit("setLoading", false);
        commit("deleteEinMails", payload);
      })
      .catch((error) => {
        console.log(error);
        commit("setLoading", false);
      });
    commit("setLoading", false);
  },
  updateEinMailsData({ commit }, payload) {
    commit("setLoading", true);
    const updateObj = {};
    Object.keys(payload).forEach((key) => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("mails")
      .doc(payload.id)
      .update(updateObj)
      .then(() => {
        commit("setLoading", false);
        commit("updateEinMails", payload);
      })
      .catch((error) => {
        console.log(error);
        commit("setLoading", false);
      });
  },
};

// mutations
const mutations = {
  setLoadedMails(state, payload) {
    state.mails = payload;
  },
  setLoadedKassen(state, payload) {
    state.kassen = payload;
  },
  setLoadedEinstellungen(state, payload) {
    state.einstellungen = payload;
  },
  setLoadedVeranstaltungen(state, payload) {
    state.veranstaltungen = payload;
  },
  setLoadedBbrBbr(state, payload) {
    state.bbrbbr = payload;
  },
  createEinMails(state, payload) {
    state.mails.push(payload);
  },
  updateEinMails(state, payload) {
    const einMails = state.mails.find((einMails) => {
      return einMails.id === payload.id;
    });
    Object.keys(payload).forEach((key) => {
      if (payload[key]) {
        einMails[key] = payload[key];
      }
    });
  },
  deleteEinMails(state, payload) {
    let array = state.mails;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.mails = array;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mails_alt.js